import React from 'react';
import { SketchPicker } from 'react-color';

import './colorPicker.scss';

export default class ColorPicker extends React.Component {

    constructor() {
        super();
        this.state = {showPicker: false};
    }

    onCanvasClick = () => {
        const {showPicker} = this.state;
        this.setState({showPicker: !showPicker});
    }

    onColorChange = (e) => {
        const {onChange} = this.props;
        this.setState({showPicker: false})
        onChange(e.hex, 'color');
    }

    render() {
        const {color} = this.props;

        return (
            <>
                
                <div className="color-field-picker"> 
                    <SketchPicker
                        color={color}
                        onChange={this.onColorChange}
                    /> 
                </div>
                
            </>
        );
    }
}